import { NavLink } from 'react-router-dom';
import { Icon } from '../utils/icons';

const Sidebar = ({ isOpen, setIsOpen }) => {
    const navItems = [
        {
            name: 'Dashboard',
            path: '/dashboard',
            icon: 'dashboard'
        },
        {
            name: 'Analytics',
            path: '/analytics',
            icon: 'analytics'
        },
        {
            name: 'Widgets',
            path: '/widgets',
            icon: 'widgets'
        },
    ];

    return (
        <>
            {/* Mobile overlay */}
            {isOpen && (
                <div
                    className="fixed inset-0 z-40 bg-secondary-900 bg-opacity-50 lg:hidden"
                    onClick={() => setIsOpen(false)}
                />
            )}

            {/* Sidebar */}
            <div
                className={`fixed inset-y-0 left-0 z-50 w-64 bg-white transform ${isOpen ? 'translate-x-0' : '-translate-x-full'
                    } transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0 border-r border-secondary-100`}
            >
                {/* Logo - Custom height to match header */}
                <div className="flex items-center justify-center px-4 py-4 bg-white border-b border-gray-200" style={{ height: '72px' }}>
                    <img
                        src={`${process.env.REACT_APP_CLOUDFRONT_URL}/assets/images/product-website-widgets-logo.svg`}
                        alt="Rannkly Widget Logo"
                        className="w-auto"
                    />
                </div>

                {/* Navigation */}
                <nav className="mt-8 px-4">
                    <div className="space-y-2">
                        {navItems.map((item) => (
                            <NavLink
                                key={item.name}
                                to={item.path}
                                className={({ isActive }) =>
                                    `group flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all duration-200 ${isActive
                                        ? 'bg-[#f3f5ff] text-[#2c4bff]'
                                        : 'text-gray-900 hover:bg-gray-50 hover:text-gray-900'
                                    }`
                                }
                                onClick={() => setIsOpen(false)}
                            >
                                {({ isActive }) => (
                                    <>
                                        <span className={`mr-3 transition-all duration-200 ${isActive ? 'text-[#2c4bff]' : 'text-gray-500 group-hover:text-gray-700'}`}>
                                            <Icon name={item.icon} size={20} />
                                        </span>
                                        {item.name}
                                    </>
                                )}
                            </NavLink>
                        ))}
                    </div>
                </nav>

            </div>
        </>
    );
};

export default Sidebar; 